// Etapa 16: formulário "Assinar PDF" (arquivo + finalidade) da página de certificados.
// O PDF e o PDF assinado ficam só na memória da página: nada vai para localStorage nem para o console.

/** Aviso fixo do modal (texto aprovado no arquivo da etapa). */
export const AVISO_VALIDADE_JURIDICA =
  'Assinatura digital tem validade jurídica. Confira o documento antes de assinar.';

/**
 * Mesmo limite padrão do servidor (SIGNING_MAX_PDF_MB = 10). É só um aviso antecipado: quem decide
 * é o servidor (se o limite dele mudar, a mensagem de erro dele aparece no modal).
 */
export const TAMANHO_MAXIMO_PDF_MB = 10;
export const TAMANHO_MAXIMO_PDF = TAMANHO_MAXIMO_PDF_MB * 1024 * 1024;
export const AVISO_PDF_GRANDE = `O PDF deve ter no máximo ${TAMANHO_MAXIMO_PDF_MB} MB`;
export const AVISO_PDF_TIPO = 'Escolha um arquivo .pdf';

/** Mesmos limites do servidor para a finalidade. */
export const FINALIDADE_MINIMO = 3;
export const FINALIDADE_MAXIMO = 200;

export interface FormularioAssinatura {
  file: File | null;
  purpose: string;
}

export function formularioAssinaturaVazio(): FormularioAssinatura {
  return { file: null, purpose: '' };
}

/** Aviso sobre o arquivo escolhido (antes de enviar); null = tudo certo. */
export function avisoDoPdf(file: Pick<File, 'name' | 'size'> | null): string | null {
  if (!file) return null;
  if (!/\.pdf$/i.test(file.name)) return AVISO_PDF_TIPO;
  if (file.size > TAMANHO_MAXIMO_PDF) return AVISO_PDF_GRANDE;
  return null;
}

export function finalidadeValida(purpose: string): boolean {
  const tamanho = purpose.trim().length;
  return tamanho >= FINALIDADE_MINIMO && tamanho <= FINALIDADE_MAXIMO;
}

export function podeAssinar(form: FormularioAssinatura): boolean {
  return !!form.file && avisoDoPdf(form.file) === null && finalidadeValida(form.purpose);
}

/** Campos exatamente como o servidor espera: file e purpose. */
export function montarFormDataAssinatura(form: FormularioAssinatura): FormData {
  const dados = new FormData();
  if (form.file) dados.append('file', form.file);
  dados.append('purpose', form.purpose.trim());
  return dados;
}

/**
 * Nome do PDF assinado: "<original>-assinado.pdf" (a mesma regra do servidor). Calculado aqui, e
 * não lido do cabeçalho da resposta, porque o navegador esconde esse cabeçalho de chamadas feitas
 * para outro domínio.
 */
export function nomeDoAssinado(nomeOriginal: string): string {
  const nome = nomeOriginal.replace(/\\/g, '/').split('/').pop() ?? '';
  const base = (/\.pdf$/i.test(nome) ? nome.slice(0, -4) : nome).trim();
  return `${base || 'documento'}-assinado.pdf`;
}

/**
 * Entrega o arquivo ao navegador como download e libera a memória logo em seguida
 * (um segundo depois do clique, para o download ter começado em qualquer navegador).
 */
export function baixarArquivo(conteudo: Blob, nome: string): void {
  const endereco = URL.createObjectURL(conteudo);
  const link = document.createElement('a');
  link.href = endereco;
  link.download = nome;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(endereco), 1000);
}
